import React from "react";
import Footer from "../navbar/footer";
import Navbarrr from "../navbar/navbarrr";
import "./contact.css";

import { Button, Form, Input } from "antd";

function Contact() {
  const onFinish = () => {
    console.log("Success:");
  };

  const onFinishFailed = () => {
    console.log("Failed:");
  };

  return (
    <div className="frrrssst">
      <Navbarrr />
      <div>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ marginTop: "3rem", opacity: "0.7" }}
        >
          <Form.Item
            label="Full Name"
            name="Full Name"
            rules={[{ required: true, message: "Please enter your fullname!" }]}
          >
            <Input />
          </Form.Item>
          <br />
          <Form.Item
            label="Email"
            rules={[{ required: true, message: "Please enter your email!" }]}
          >
            <Input />
          </Form.Item>{" "}
          <br />
          <Form.Item
            label="Phone Number"
            rules={[
              { required: true, message: "Please enter your phone number!" },
            ]}
          >
            <Input />
          </Form.Item>
          <br />
          <Form.Item
            label="Message"
            rules={[{ required: true, message: "Please enter your message!" }]}
          >
            <Input style={{ height: "6rem" }} />
          </Form.Item>
          <br />
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>{" "}
      <Footer />
    </div>
  );
}

export default Contact;
